import { Link } from "react-router-dom";
import { statusBadgeVariant } from "./workerLineShared.js";

/**
 * One org-chart node card (Prompt 137) - the root SuperAdmin box, a Super
 * Agent/PLC/Agent card (real name/code/status/stat line, clickable to open
 * the node's own drawer), or a dashed "ghost" create-link card for an empty
 * branch (a real `<Link>` into the already-existing Create drawer, never a
 * fake/dead control). Card width is capped (see .wx-oc-node in
 * workerLine.css) and centered within whatever grid cell it renders in, so
 * a lone sibling in an otherwise-wide equal-width lane never looks stretched
 * - "Node sizes stable and professional" per the owner's own requirement.
 */
export default function OrgNode({ kind, name, code, status, statLine, selected, onClick, href, ghostLabel }) {
  if (kind === "root") {
    return (
      <div className="wx-oc-node wx-oc-node--root">
        <span className="wx-oc-node-name">{name}</span>
      </div>
    );
  }

  if (href) {
    return (
      <Link to={href} className="wx-oc-node wx-oc-node--ghost">
        <span className="wx-oc-node-ghost-plus" aria-hidden="true">
          +
        </span>
        <span className="wx-oc-node-name">{ghostLabel}</span>
      </Link>
    );
  }

  return (
    <button type="button" className={`wx-oc-node wx-oc-node--${kind}${selected ? " wx-oc-node--selected" : ""}`} onClick={onClick}>
      <div className="wx-oc-node-head">
        <span className="wx-oc-node-name">{name}</span>
        {status && <span className={`wx-badge wx-badge--${statusBadgeVariant(status)} wx-oc-node-badge`}>{status}</span>}
      </div>
      {code && <span className="wx-oc-node-code">{code}</span>}
      {statLine && <span className="wx-oc-node-stat">{statLine}</span>}
    </button>
  );
}
